import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../enums';

const Component = () => import('./GlobalMenuGroupManagement.vue');

export default {
  path: buildChildURL(GlobalMenuGroupsRoutePathNames.ID, GlobalMenuGroupsRoutePathNames.MANAGEMENT),
  name: GlobalMenuGroupsRouteNames.GLOBAL_MENU_GROUPS_MANAGEMENT,
  component: Component,
} as RouteRecordRaw;
